export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5132.77fda7d5.jpg";